module.exports = __webpack_public_path__ + "img/tokyu-main.29a8452a.svg";